import { Injectable } from '@angular/core';
import { clamp } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';
import {
  MouseEventService,
  WheelEventInfo,
} from '../../../cross-team-shared/misc-services/events/mouse-event.service';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { pointToVector, vectorToPoint } from '../../utils/point-cloud-utils';
import { MainCameraService } from './main-camera.service';

const MIN_DISTANCE_FROM_TARGET = 0.5;
const MAX_DISTANCE_FROM_TARGET = 150;

@Injectable()
export class DollyService extends InjectableSuperclass {
  constructor(
    private mouseEventService: MouseEventService,
    private mainCameraService: MainCameraService,
    private store: PointCloudContentStore,
  ) {
    super();
  }

  setUpSubscriptions() {
    this.subscribeTo(
      this.mouseEventService.getEvent$('container', 'wheel'),
      this.dollyWithWheel,
    );
  }

  // Called 'zoom' in the UI
  private dollyWithWheel({ event }: WheelEventInfo) {
    event.preventDefault();
    const position = pointToVector(this.store.state().camera.position);
    const target = pointToVector(this.store.state().camera.target);

    const initialDistance = position.distanceTo(target);

    const dollyFactor = 1 + Math.sign(event.deltaY) * 0.1;
    const finalDistance = clamp(
      initialDistance * dollyFactor,
      MIN_DISTANCE_FROM_TARGET,
      MAX_DISTANCE_FROM_TARGET,
    );

    if (initialDistance !== finalDistance) {
      const newPosition = position
        .sub(target)
        .multiplyScalar(finalDistance / initialDistance)
        .add(target);

      const newCameraState = { position: vectorToPoint(newPosition) };

      this.mainCameraService.updateAccumulatedDollyDistance(
        finalDistance / initialDistance,
      );
      this.mainCameraService.updateCameraAndTrack('dolly', newCameraState);
    }
  }
}
